import { Theme } from '@mui/material/styles';
import { multiplyBorderRadius } from '@shared/theme/util';

export const CHAT_WIDTH = 400;
export const CHAT_HEIGHT = 600;
export const HISTORY_WIDTH = 200;
export const TRANSITION_DURATION = 300;

export const MIN_CHAT_WIDTH = 320;
export const MIN_CHAT_HEIGHT = 280;

export const chatbotStyles = {
  paper: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: multiplyBorderRadius(theme, 2),
  }),
  button: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.secondary.main}`,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.secondary.dark,
    },
  }),
};
